/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/has_feature_flags" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdHasFeatureFlags } from "./constants";
import type { EngagementAppGroupIdHasFeatureFlagsResult } from "./types";

export const getEngagementAppGroupIdHasFeatureFlags = reactQueryFetcherAdapter(
  engagementAppGroupIdHasFeatureFlags,
  (
    signal: AbortSignal,
    appGroupId: string,
    includeArchivedFlags: boolean
  ): Promise<EngagementAppGroupIdHasFeatureFlagsResult> => {
    return fetch(
      `/engagement/${appGroupId}/has_feature_flags`,
      "GET",
      { include_archived_flags: includeArchivedFlags },
      { signal }
    );
  }
);
